import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import '../../styles/sections/sectorContact.css';
import CopyModal from '../modals/CopyModal';
import { sectorImages } from '../../constants/images';
import { checkIsMobile } from '../../utils/deviceUtils';

const SectorContact = ({ motionProps }) => {
  const [isMobile, setIsMobile] = useState(checkIsMobile(window.innerWidth));
  const [isLoaded, setIsLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(checkIsMobile(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleEmailClick = () => {
    const email = "apply@ksgc.global";
    navigator.clipboard.writeText(email);
    setShowModal(true);
  };

  const bgImage = sectorImages.sectorContact.bg[isMobile ? 'mobile' : 'pc'];

  return (
    <section
      {...motionProps}
      className="section_container sector_contact"
      id="sector_contact"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="contact_content">
        <div className="image_container">
          <img 
            src={sectorImages.sectorContact.contactImages.contact1[isMobile ? 'mobile' : 'pc']}
            alt="Contact Information 1" 
            className="contact_image"
          />
          <img 
            src={sectorImages.sectorContact.contactImages.contact2[isMobile ? 'mobile' : 'pc']}
            alt="Contact Information 2" 
            className="contact_image"
          />
          <div className="inline_images">
            <div className="images_wrapper">
              <div className="contact_image_wrapper">
                <img
                  src={sectorImages.sectorContact.contactImages.contact3[isMobile ? 'mobile' : 'pc']}
                  alt="Contact Email"
                  className="contact_image inline contact4_1st"
                  id="email_elm"
                  onClick={handleEmailClick}
                />
              </div>
              {isMobile ? (
                <a href="tel:+82-2-3440-7306" className="phone-link">
                  <img
                    src={sectorImages.sectorContact.contactImages.contact4[isMobile ? 'mobile' : 'pc']}
                    alt="Contact Phone"
                    className="contact_image inline contact4_2nd"
                  />
                </a>
              ) : (
                <img
                  src={sectorImages.sectorContact.contactImages.contact4[isMobile ? 'mobile' : 'pc']}
                  alt="Contact Phone"
                  className="contact_image inline contact4_2nd"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <CopyModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </section>
  );
};

SectorContact.propTypes = {
  motionProps: PropTypes.shape({
    initial: PropTypes.object,
    whileInView: PropTypes.object,
    viewport: PropTypes.object,
    transition: PropTypes.object
  })
};

export default SectorContact; 